/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FC, useState } from "react";

interface IntervalSelectorProps {
  label?: string;
  timeRange: number[];
  interval?: number;
  disabled?: boolean;
  onSelected?: (interval: number) => void;
}
export const IntervalSelector: FC<IntervalSelectorProps> = ({
  label,
  timeRange,
  disabled,
  interval,
  onSelected,
}) => {
  const [selectedInterval, setSelectedInterval] = useState(interval ?? 15);
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        sx={{ width: "100%", backgroundColor: "white" }}
        size="small"
        disabled={disabled}
        value={selectedInterval.toString()}
        onChange={(e) => setSelectedInterval(Number(e.target.value))}
        // disabled={item.startType === "manual"}
      >
        {timeRange.map((time) => (
          <MenuItem key={time} value={time}>
            {time}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
